import useUrls from './useUrls'

/**
 * This composition function is used to manage the changes in context and update the URL on
 * the browser.
 */
export default function useUrlManager(model) {

  const context = computed(() => model.context.value)
  let manage = false
  /**
   * We implement the watch function to watch for changes in the reactive context object.  If it changes, then
   * we want to update the Url on the browser.
   */
  watch(
    () => context,
    (oldVal, newVal) => {
      updateUrl()
    },
    { deep: true }
  )

  /**
   * Update the browser URL with Url params built up from the context.
   */
  const updateUrl = () => {

    const { buildUrl } = useUrls(model.context.value)

    //const { buildUrl } = useUrls(profile.value, context.value)
    if (!process.server) {
      const url = buildUrl('/fcp/csearch/')
      history.pushState({}, '', url)
    }
  }

  const manageUrls = () => {
    manage = true
    updateUrl()
  }

  /**
   * Clear safelink-related items from context.
   */
  const clearSafelinkItems = () => {
    delete model.context.value.safelink
    delete model.context.value.marketingGroup
    delete model.context.value.networkId
    delete model.context.value.asOfDate
    delete model.context.value.empId
  }

  return { manageUrls, clearSafelinkItems }
}